import { storyStep } from './constant'

// A locked story card sends the learner to STORY_FINISHED without opening the story, so the reader
// state still holds whichever story was open before. Navigating with this state tells the finished
// page that nothing was read, so it must not record FINISH against that stale story.
export const LOCKED_STORY_REDIRECT_STATE = { lockedStoryRedirect: true }

export const isLockedStoryRedirect = (navigationState: unknown): boolean =>
  Boolean((navigationState as { lockedStoryRedirect?: boolean } | null)?.lockedStoryRedirect)

interface FinishStepInput {
  storyId?: string
  level?: string
  lastStepEnum: storyStep | null | undefined
  navigationState: unknown
}

// FINISH is saved once, when a learner reaches the finished page from the reader for a story they
// have not finished before. A locked-card redirect never read anything, so it never counts.
export const shouldSaveFinishStep = ({ storyId, level, lastStepEnum, navigationState }: FinishStepInput): boolean =>
  Boolean(storyId && level) &&
  lastStepEnum !== null &&
  lastStepEnum !== undefined &&
  lastStepEnum < storyStep.Step4 &&
  !isLockedStoryRedirect(navigationState)
